var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"hide-tablet"},[_vm._v(" "+_vm._s(_vm.$t("progress.completedText", { completedSections: _vm.completedSections, totalSections: _vm.totalSections }))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }